module.exports = __webpack_public_path__ + "img/ico-newspaper.7f2d9adb.svg";